export enum EnumTypeDocumentWdh {
  FACTURE = 'Facture',
  AVOIR = 'Avoir',
  BRM = 'BRM',
  BI = 'BI',
  BP = 'BP',
  ATTESTATION_VALO = 'ATTESTATION_VALO',
  FICHE_DECLASSEMENT = 'BR',
  AUTRES = 'Autres',
}

export enum EnumDocTypeVisibility {
  VISIBLE_IN_CLIENT = 'VISIBLE_IN_CLIENT',
  VISIBLE_IN_INTERNAL = 'VISIBLE_IN_INTERNAL',
  VISIBLE_IN_ALL = 'VISIBLE_IN_ALL',
}
